export default __webpack_public_path__ + "static/media/learn_landing.07bf27a0.jpg";